export default "__VITE_ASSET__C$QuqhgZ__"